import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import FormInput from "../molecules/FormInput";
import { FormEvent, useEffect, useState } from "react";
import { AuthService, UserService } from "../../services/api";
import { useGlobalContext } from "../../stores/Global";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { UpdateUserLanguageLanguageEnum } from "../../services/swagger";
import { startServiceWorker } from "../../workers/main";

interface OTPDialogProps {
  open: boolean;
  handleClose: (success: boolean) => void;
}

export default function OTPDialog(props: OTPDialogProps) {
  const { t } = useTranslation("OTPDialog");
  const { context, setContext } = useGlobalContext();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");

  useEffect(() => {
    if (props.open) setOtp("");
  }, [props.open]);

  const handleSubmit = async (e: FormEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setLoading(true);
    try {
      const res = await AuthService.otpLogin({
        otp,
        token: localStorage.getItem("authToken") || "",
      });
      if (res?.data?.success) {
        props.handleClose(true);
        localStorage.setItem("authToken", res.data.data?.token || "");
        await UserService.updateUserLanguage({
          language: context.language as UpdateUserLanguageLanguageEnum,
        });
        startServiceWorker();
        setContext({ ...context, user: res.data.data?.user });
        navigate("/");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      onClose={loading ? undefined : props.handleClose}
      open={props.open}
      component="form"
      onSubmit={handleSubmit}
    >
      <DialogTitle>
        <Typography variant="h4" gutterBottom>
          {t("OneTimePassword")}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ maxWidth: 400 }}>
        <Typography mb={4}>{t("PleaseEnterOtp")}</Typography>
        <FormInput
          autoFocus
          label={t("OtpCode")}
          field="code"
          type="string"
          inputType="number"
          inputMode="numeric"
          value={otp}
          onChange={(value) => setOtp(value as string)}
        />
      </DialogContent>
      <DialogActions>
        <Button
          color="error"
          variant="outlined"
          onClick={loading ? undefined : () => props.handleClose(false)}
          disabled={loading}
        >
          {t("Cancel")}
        </Button>
        <Button type="submit" variant="contained" loading={loading}>
          {t("Confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
